import {Fragment, useEffect, useState, createRef} from 'react';
import Checkbox from "../Checkbox/Checkbox";
import Input from "../Input/Input";
import {useGlobalState} from "../../GlobalStateProvider";
import {KeySolver} from "../../KeySolver";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const Answer: (props: any) => JSX.Element = (props: any) => {

    const input = createRef<HTMLInputElement>();
    const [inputIsActive, setInputIsActive] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const {children, isString, isRadio, name, defaultValue, image, categories, subItem, subItems, i, k, value} = props;

    const {state, setState} = useGlobalState();
    const { inputValues } = state;

    // const handleChange = useCallback((val: string) => {
    //     setInputValue(val);
    //     const updatedInputValues = [{defaultValue: defaultValue, inputVal: val}];
    //     setState({ ...state, inputValues: updatedInputValues });
    // }, [defaultValue, setState, state]);

    // const handleChange = (val: string) => {
    //     setInputValue(val);
    // }

    // useEffect(() => {
    //     if (inputIsActive && input && input.current !== undefined) {
    //         const el: HTMLInputElement = input.current as HTMLInputElement;
    //         el.focus();
    //     }
    //     if(inputValues.some(element => element.defaultValue === defaultValue)) {
    //         const foundElement = inputValues.find(element => element.defaultValue === defaultValue);
    //         setInputValue(foundElement.inputVal);
    //     }
    // }, [inputIsActive, inputValues, defaultValue, handleChange]);

    useEffect(() => {
        if(inputValue !== '') {
            const updatedInputValues = [{defaultValue: defaultValue, inputVal: inputValue}];
            setState({ ...state, inputValues: updatedInputValues });
        }
    }, [inputValue, defaultValue, state, setState]);

    return (
        <Fragment>
            <div className={`${subItem ? 'text-[0.9rem] md:text-[1.4rem]' : 'text-[1.2rem] md:text-[1.8rem]'} font-semibold mb-10`}>
                <div className={image || isString ? 'flex flex-row items-center relative' : ''}>
                    <div>
                        <Checkbox name={!isString && name} isRadio={isRadio} defaultValue={defaultValue} setInputIsActive={(p: boolean) => setInputIsActive(p)} >
                            {!isString &&
                                <div dangerouslySetInnerHTML={{ __html: children }} />
                            }
                        </Checkbox>
                    </div>
                    {isString &&
                        <Fragment>
                            <div className={`relative w-full ${(inputValues.some(element => element.defaultValue === defaultValue) || inputIsActive) ? '' : ' pointer-events-none opacity-[0.5]'}`}>
                                <Input attributes={{placeholder: 'Text eingeben ...', ref: input, name: name, autoFocus: ( !!(inputValues.some(element => element.defaultValue === defaultValue) || inputIsActive) )}} defaultValue={inputValue !== '' ? inputValue : ( inputValues.some(element => element.defaultValue === defaultValue) ? inputValues.find(element => element.defaultValue === defaultValue).inputVal : '') } onChange={(p: string) => setInputValue(p)} />
                                <button type="button" className="absolute top-0 right-0 z-[99] mt-[10px] lg:mt-[5px] me-[15px] transition-all text-gray-300 hover:text-gray-500" onClick={() => setInputValue(' ')}>
                                    <FontAwesomeIcon icon={icon({name: 'xmark', style: 'solid'})} size="sm"/>
                                </button>
                            </div>
                        </Fragment>
                    }
                    {image &&
                        <img src={image} alt="" className="rounded-full w-[90px] h-[90px] lg:w-[150px] lg:h-[150px] object-cover drop-shadow-lg" />
                    }
                    {inputIsActive && categories && categories.length > 0 &&
                        <Fragment>
                            <ul>
                                {categories.map((category: any) =>
                                    <Fragment key={KeySolver()} >
                                        <input type="hidden" name={`survey[categories][${category}][]`} defaultValue={value} />
                                    </Fragment>
                                )}
                            </ul>
                        </Fragment>
                    }
                </div>
            </div>
            {inputIsActive && subItems && subItems.length > 0 &&
                <div className="lg:col-span-2 bg-white drop-shadow-lg p-5 rounded-lg mb-20">
                    <div className={`${subItems.length > 5 ? 'lg:grid lg:grid-cols-2' : ''}`}>
                        {subItems.map((childItem: any, x: number) =>
                            <Fragment key={KeySolver()} >
                                <Answer name={`survey[questions][${i}][answer][${k}][subAnswer]${childItem.isMultiple ? `[${x}]` : ''}`} isRadio={!childItem.isMultiple} isString={childItem.properties.isString} defaultValue={childItem.properties.identifier} subItem={true} >{childItem.properties.text}</Answer>
                            </Fragment>
                        )}
                    </div>
                </div>
            }
        </Fragment>
    );
}

export default Answer;
